import { GraphQLClient } from 'graphql-request';

/**
 * Graphqlclient Context to pass into API Calls
 * /api/users/graphql
 */
const ENDPOINT = process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT;

let headers: { [key: string]: string } = {};
let graphClientCache: { [key: string]: GraphQLClient } = {};

function getHeaders() {
    return headers;
}

function setHeaders(headersToSet: { [key: string]: string }) {
    Object.assign(headers, headersToSet);
}

function getClient(
    type:
        | 'users'
        | 'courses'
        | 'files'
        | 'admin'
        | 'materials'
        | 'submissions'
        | 'templates'
        | 'calendar'
        | 'communication'
        | 'comments'
        | 'notifications',
) {
    if (typeof window === 'undefined') return null as never;
    let c = graphClientCache[type];
    if (!c) {
        c = new GraphQLClient(`${window.location.origin}/api/${type}/graphql`);
        graphClientCache[type] = c;
    }
    c.setHeaders(getHeaders());

    return c;
}

/**
 * Refreshing the Client removes all the Base Headers this client users with Authorization thats attached
 * as part of the React Query Session Hooks.
 *
 * Graphql Namespaces are going to be sub pathed based on URL's ['/api/users/graphql', '/api/courses/graphql'] etc...
 *
 */
function refreshClient() {
    headers = {};
    graphClientCache = {};
}

export { refreshClient, setHeaders, getClient, getHeaders, ENDPOINT };
